module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/online-lessons-90e20e22d3d78881edfded0e4a92d9f7.svg";